(function ($) {
	class W4D_Instashop {
		constructor() {
			this.isPopupOpen = false;
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.body = $('body');
			this.instashop2Marker = '.instashop-2__marker';
			this.instashop2Popup = '.instashop-2__popup';

			this.overlaySelector = '.instashop-2__mobile-overlay';
			this.activeOverlayClass = 'instashop-2__mobile-overlay--active';
			this.bodyActiveClass = 'instashop-mobile-overlay-active';
		}

		bindEvents() {
			$(document).on('click', this.instashop2Marker, (e) => {
				e.stopPropagation();
				this.handleMarkerClick($(e.currentTarget));
			});
			$(document).on('click', (e) => {
				if (!this.isPopupOpen) return;

				const $target = $(e.target);
				const isClickOnPopup = $target.closest(this.instashop2Popup).length > 0;
				const isClickOnMarker = $target.closest(this.instashop2Marker).length > 0;

				if (!isClickOnPopup && !isClickOnMarker) {
					this.closePopup();
				}
			});

			$(document).on('click', '.js-instashop-open-mobile-overlay', (e) => {
				const $block = $(e.currentTarget).closest('.instashop-2');
				const $overlay = $block.find(this.overlaySelector);
				this.openMobileOverlay($overlay);
			});

			$(document).on('click', '.js-instashop-close-mobile-overlay', (e) => {
				const $overlay = $(e.currentTarget).closest(this.overlaySelector);
				this.closeMobileOverlay($overlay);
			});

			$(document).on('click', this.overlaySelector, (e) => {
				if (e.target === e.currentTarget) {
					this.closeMobileOverlay($(e.currentTarget));
				}
			});
		}

		openMobileOverlay($overlay) {
			if (window.innerWidth > 768) return;
			this.body.addClass(this.bodyActiveClass);
			$overlay.addClass(this.activeOverlayClass);
		}

		closeMobileOverlay($overlay) {
			this.body.removeClass(this.bodyActiveClass);
			$overlay.removeClass(this.activeOverlayClass);
		}

		handleMarkerClick($marker) {
			if (window.innerWidth > 768) {
				const popupTarget = $marker.data('popup-target');
				const $popup = $(popupTarget);

				if ($popup.hasClass('instashop-2__popup--active')) {
					this.closePopup();
				} else {
					this.closePopup();
					this.positionAndShowPopup($marker, $popup);
				}
			} else {
				this.body.addClass(this.bodyActiveClass);
				$marker.parent().parent().find(this.overlaySelector).addClass(this.activeOverlayClass);
			}
		}

		positionAndShowPopup($marker, $popup) {
			const markerPos = $marker.position();
			const markerW = $marker.outerWidth();
			const markerH = $marker.outerHeight();

			const popupW = $popup.outerWidth();
			const popupH = $popup.outerHeight();

			const $container = $marker.closest('.instashop-2__content');
			const contW = $container.innerWidth();
			const contH = $container.innerHeight();

			let topValue = markerPos.top + markerH / 2 - popupH / 2;
			if (topValue < 10) topValue = 10;
			if (topValue + popupH > contH - 10) topValue = contH - popupH - 10;

			const spaceRight = contW - (markerPos.left + markerW);
			const leftValue = spaceRight < popupW + 10 ? markerPos.left - popupW - 10 : markerPos.left + markerW + 10;

			$marker.addClass('instashop-2__marker--active');
			$popup.addClass('instashop-2__popup--active');
			$popup.css({
				'--top-offset': topValue + 'px',
				'--left-offset': leftValue + 'px',
			});

			this.isPopupOpen = true;
		}

		closePopup() {
			$(this.instashop2Marker).removeClass('instashop-2__marker--active');
			$(this.instashop2Popup).removeClass('instashop-2__popup--active');
			this.isPopupOpen = false;
		}
	}

	$(document).ready(function () {
		window.W4D_Instashop = new W4D_Instashop();
	});
})(jQuery);
